import ChatLeftPanel from "./left-panel"
import RightPanel from "./right-panel"
import { useSelector } from "react-redux"
import { cn } from "@/lib/utils"

function ChatPage() {
  const chats = useSelector((state) => state.chats)
  const isMobileView = chats?.selectedContact ? true : false

  return (
    <div className="h-[calc(100vh-120px)] flex relative">
      <div
        className={cn(
          "w-full lg:w-[320px] xl:w-[380px] absolute lg:relative h-full",
          isMobileView && "hidden lg:block"
        )}
      >
        <ChatLeftPanel />
      </div>
      <div
        className={cn(
          "w-full lg:flex-1 absolute lg:relative h-full bg-white dark:bg-gray-900",
          !isMobileView && "hidden lg:block"
        )}
      >
        <RightPanel />
      </div>
    </div>
  )
}

export default ChatPage
